import { InputSelectHelper } from '@helpers/input-select.helper';

/**
 * Chart interval in MINUTES → the API's interval string. One table for the whole app:
 * it used to be pasted into every place that builds a candle request, which is how the
 * chart and its lazy-scroll could drift apart on a newly added interval.
 */
/* eslint-disable @typescript-eslint/naming-convention -- keys are interval minutes, not identifiers */
const API_INTERVAL_BY_MINUTES: Record<number, string> = {
	1: '1m',
	3: '3m',
	5: '5m',
	15: '15m',
	30: '30m',
	60: '1h',
	120: '2h',
	240: '4h',
	360: '6h',
	480: '8h',
	720: '12h',
	1440: '1d',
	4320: '3d',
	10080: '1w',
	43200: '1M',
};
/* eslint-enable @typescript-eslint/naming-convention */

export class IntervalHelper {
	/** API interval string for a chart interval given in minutes (defaults to '5m'). */
	static apiString(minutes: number): string {
		return API_INTERVAL_BY_MINUTES[minutes] ?? '5m';
	}

	static intervalsMap(): Map<number, Interval> {
		const intervals = InputSelectHelper.getIntervals();
		const intervalsMap = new Map<number, Interval>();

		for (const i of intervals) {
			intervalsMap.set(i.value as number, i as Interval);
		}

		return intervalsMap;
	}
}

type Interval = { label: string; value: number };
